import React from 'react';

const AnnouncementSvg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="30" height="30">
    <defs>
      <linearGradient id="blueGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#4285f4" />
        <stop offset="100%" stopColor="#3367d6" />
      </linearGradient>
      <linearGradient id="redGrad" x1="0%" y1="0%" x2="100%" y2="0%">
        <stop offset="0%" stopColor="#ea4335" />
        <stop offset="100%" stopColor="#d33b2c" />
      </linearGradient>
    </defs>

    {/* Megaphone body (blue trapezoid) */}
    <path
      d="M 18 22 L 32 18 L 32 46 L 18 42 Z"
      fill="url(#blueGrad)"
      stroke="#2c5aa0"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />

    {/* Horn/speaker (red cone) */}
    <path
      d="M 32 18 L 52 12 L 52 52 L 32 46 Z"
      fill="url(#redGrad)"
      stroke="#b71c1c"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />

    {/* Handle */}
    <rect x="14" y="38" width="8" height="25" rx="2" fill="#ffa726" stroke="#f57c00" strokeWidth="1.5" />

    {/* Sound waves */}
    <g opacity="0.8">
      <path
        d="M 56 26 Q 58 28, 58 32 Q 58 36, 56 38"
        fill="none"
        stroke="#4285f4"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
      <path
        d="M 60 22 Q 64 26, 64 32 Q 64 38, 60 42"
        fill="none"
        stroke="#4285f4"
        strokeWidth="2.5"
        strokeLinecap="round"
      />
    </g>

    {/* Shine highlight */}
    <ellipse cx="38" cy="24" rx="6" ry="3" fill="white" opacity="0.3" />
  </svg>
);

export default AnnouncementSvg;
